import React from "react";
import { useLocation } from "react-router-dom";
import Footer from "./NewFooter/footer";

const FooterGate = () => {
  const location = useLocation();
  if (location.pathname.startsWith("/dashboard")) {
    return null;
  }
  return <Footer />;
};

export default FooterGate;
